import { Shell, StepFooter } from "@/components/Shell";
import { SYMPTOMS, IMPACT_QUESTIONS, MENSTRUAL_LABEL, AGE_RANGES } from "@/lib/questions";

export function Review({ state, onBack, onSubmit, progress }) {
  const ageLabel =
    AGE_RANGES.find((a) => a.id === state.menstrual?.age_range)?.label ||
    "No especificado";
  const menstrualLabel = MENSTRUAL_LABEL(state.menstrual || {});

  const answeredSymptoms = SYMPTOMS.filter((s) => {
    const v = state.symptoms?.[s.id];
    return typeof v === "number" && v > 0;
  });

  return (
    <Shell progress={progress}>
      <span className="cc-eyebrow">Revisión</span>
      <h1 className="font-serif text-3xl sm:text-4xl mt-3">
        Revisa antes de continuar
      </h1>
      <p className="mt-3 text-[hsl(var(--muted-foreground))]">
        Un resumen breve de lo que has compartido.
      </p>

      <div className="mt-6 space-y-4">
        <div className="cc-card p-5">
          <p className="cc-eyebrow">Situación</p>
          <p className="mt-2 font-medium">Rango de edad: {ageLabel}</p>
          <p className="mt-1 text-[hsl(var(--muted-foreground))]">{menstrualLabel}</p>
        </div>

        <div className="cc-card p-5">
          <p className="cc-eyebrow">Síntomas con intensidad</p>
          {answeredSymptoms.length === 0 ? (
            <p className="mt-2 text-[hsl(var(--muted-foreground))] text-sm">
              No indicaste síntomas con intensidad.
            </p>
          ) : (
            <ul className="mt-2 space-y-1 text-sm">
              {answeredSymptoms.map((s) => (
                <li key={s.id} className="flex justify-between gap-3">
                  <span>{s.text}</span>
                  <span className="cc-chip">
                    {state.symptoms[s.id]} / 3
                  </span>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="cc-card p-5">
          <p className="cc-eyebrow">Impacto declarado</p>
          <ul className="mt-2 space-y-1 text-sm">
            {IMPACT_QUESTIONS.map((q) => {
              const v = state.impact?.[q.id];
              return (
                <li key={q.id} className="flex justify-between gap-3">
                  <span>{q.text}</span>
                  <span className="cc-chip">
                    {typeof v === "number" ? `${v} / 3` : "—"}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      </div>

      <StepFooter>
        <button onClick={onBack} className="cc-btn-outline" data-testid="review-back-btn">
          Atrás
        </button>
        <button onClick={onSubmit} className="cc-btn-primary" data-testid="review-submit-btn">
          Ver mi resultado
        </button>
      </StepFooter>
    </Shell>
  );
}
